export default __webpack_public_path__ + "static/media/logo-ae-pottery-barn.47f17ca4.svg";